// extracted by mini-css-extract-plugin
export default {"capitalize":"file-preview_capitalize__h-erg"};